import { CommonResponse } from "src/model/common";
import { TradeDataReports } from "src/model/report";
import { getRequest, postRequest } from "src/services/api/http";
import { URL_ENDPOINT } from "src/utils/constants/service";


export const ReportService = {
  getTradeDataReport,
  createTradeDataReport
}

function getTradeDataReport(params: Record<string, string | number>) {
  const url = URL_ENDPOINT.myReport.getTradeDataReport
  return getRequest(url, params, new TradeDataReports()) as Promise<TradeDataReports>;
}
function createTradeDataReport(dto: Record<string, string | any>) {
  const url = URL_ENDPOINT.myReport.createTradeDataReport
  return postRequest(url, dto) as Promise<CommonResponse>;
}